export const sfNames = {
  accessRole: 'accessRole',
  accessOperations: 'accessOperations',
  accessToUserGroups: 'accessToUserGroups',
  accessToScreen: 'accessToScreen',
  extendedAccess: 'extendedAccess',
  responsibleForUnits: 'responsibleForUnits',
  restrictedAccess: 'restrictedAccess',
  personExcluded: 'personExcluded',
  accessToAssignRoles: 'accessToAssignRoles',
  additionalInformation: 'additionalInformation',
  defaultValues: 'defaultValues',  
  userCode: 'userCode',
  experienceTransferAlerts: 'experienceTransferAlerts'
};

export const sfParameters = {
  application: 'application',
  caseType: 'caseType',
  defaultValue: 'defaultValue',
  codeTable: 'codeTable',
  extraInfo: 'extraInfo',
  domainNode: 'domainNode',
  unit: 'unit',
  subset: 'subset',
  operation: 'operation',
  field: 'field',
  role: 'role',
  id: 'id'
};
